var jsonURL = '/material/json/pointcpList.json';
var request = new XMLHttpRequest();
request.open('HEAD', window.location.href, true);
request.send();

request.onreadystatechange = function() {
	if (this.readyState === 4) {
		// サーバーから時刻を取得
		var serverDate = new Date(request.getResponseHeader('Date'));

		// JSONからデータを取得し、画面に表示する
		$(window).on('load', function() {
			fetch(jsonURL)
				.then(response => response.json())
				.then(data => formatJSON(data, serverDate));
		});
	}
};

// JSONから取得したデータを整形し、画面に表示する
var formatJSON = function(json, serverDate) {
	// ポイントアップキャンペーン中欄に表示するhtml
	var pointcpWrap = '';
	// キャンペーン内容ごとにデータを抽出
	for (let i = 0; i < json.length; i++) {
		var cpBlock = json[i];
		var cpData = cpBlock.data;
		// 表示するデータ
		var displayCpData = [];
		// 表示するデータを絞り込む
		for (let n = 0; n < cpData.length; n++) {
			var data = cpData[n];
			if (timeCheck(data.startDate, data.endDate, serverDate)) {
				displayCpData.push(data);
			};
		}
		// 表示するデータがある場合
		if (displayCpData.length > 0) {
			// キャンペーン見出しをhtml表記に整形
			var cpTitleHTML = '<div class=\"pointcp__title mt50\" id=\"' + cpBlock.blockId + '\"><span class=\"title-text--normal\">' + cpBlock.frequency + '</span><div class=\"title-text--emphasis\"><span class=\"text__number\">' + cpBlock.multiple + '</span><span class=\"text__unit\">倍</span></div></div>';
			// 絞り込んだデータをhtml表記に整形
			var gridWrapperHTML = '<div class=\"grid-wrapper mt30\"><div class=\"grid grid--6-icononly grid--sp-3-icononly\">';
			for (let l = 0; l < displayCpData.length; l++) {
				var gridItemFrontHTML = '<div class=\"grid-item icon__open-modal\" id=\"' + displayCpData[l].id + '\"><div class=\"pointcp-item\">';
				var gridItemBackHTML = '</div></div>';
				var itemHTML = '';
				// ロゴの画像がある場合
				if (displayCpData[l].logoPath) {
					itemHTML = '<div class=\"pointcp__logo\"><img src=\"' + displayCpData[l].logoPath + '\" alt=\"' + displayCpData[l].imgAltName + '\"></div>';
				} else {
					itemHTML = '<div class=\"pointcp__text\"><span class=\"store-name\">' + displayCpData[l].storeName + '</span></div>';
				}
				var gridItem = gridItemFrontHTML + itemHTML + gridItemBackHTML;
				gridWrapperHTML += gridItem;
			}
			gridWrapperHTML += '</div></div>';
			// キャンペーン内容ごとに作成したブロックを繋ぎ合わせる
			pointcpWrap += (cpTitleHTML + gridWrapperHTML);
		}
	}
	// キャンペーン中欄に表示
	$('#pointcp-list')[0].innerHTML = pointcpWrap;
	// URLにハッシュ値がある場合
	var urlHash = location.hash;
	if (urlHash) {
		scrollToUrlHash(urlHash);
	}
};

// 開始日、終了日を基に、表示非表示を判定する
var timeCheck = function(startDate, endDate, serverDate) {
	// 各加盟店ごとに境界時間を取得
	var limitDateAStart = new Date(startDate);
	var limitDateAEnd = new Date(endDate);
	// 各境界時間までの秒数を宣言
	var rTimeAStart = (limitDateAStart - serverDate) / 1000;
	var rTimeAEnd = (limitDateAEnd - serverDate) / 1000;
	return rTimeAStart < 0 && !(rTimeAEnd < 0);
};

// URLで指定されている位置までスクロールする
var scrollToUrlHash = function(urlHash) {
	if ($(urlHash).length) {
		var position = $(urlHash).offset().top;
		var headerHeight = $('#js-header').outerHeight();
		if ($(window).width() > 768) {
			position -= headerHeight;
		}
		position -= 20;
		$('html,body').animate({ scrollTop: position }, 900);
	}
};
